import { motion } from "framer-motion";
import { TrendingUp, Shield, Microscope, Globe, ArrowRight } from "lucide-react";
import { BilingualEyebrow, BilingualHeading } from "@/components/ui/bilingual-heading";
import { useLanguage } from "@/contexts/LanguageContext";

const pillarMeta = [
  { icon: Globe, key: "market" },
  { icon: Shield, key: "ip" },
  { icon: Microscope, key: "trl" },
  { icon: TrendingUp, key: "model" },
];

export default function InvestmentSection() {
  const { t } = useLanguage();
  const pillars = pillarMeta.map(p => ({
    ...p,
    title: t(`investment.pillars.${p.key}T`),
    desc: t(`investment.pillars.${p.key}D`),
  }));

  return (
    <section id="investment" data-testid="investment-section" className="py-24 md:py-32 bg-[#050505] relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#EE1D25]/4 rounded-full blur-[200px]" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="mb-16 max-w-2xl">
          <BilingualEyebrow en="Investment Opportunity" hu="Befektet&eacute;si lehet&#337;s&eacute;g" className="text-[#9CA3AF]" />
          <BilingualHeading en="Building Scalable Biodefense Infrastructure" hu="Sk&aacute;l&aacute;zhat&oacute; biov&eacute;delemi infrastrukt&uacute;ra &eacute;p&iacute;t&eacute;se" colorClass="text-[#F3F4F6]" />
          <p className="text-base text-[#9CA3AF] mt-5 leading-relaxed">
            {t("investment.sub")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#1F2937] mb-12">
          {pillars.map((p, i) => (
            <motion.div
              key={p.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="bg-[#050505] p-7 md:p-9"
            >
              <p.icon size={20} className="text-[#EE1D25] mb-4" />
              <h3 className="font-heading text-base font-semibold text-[#F3F4F6] mb-3">{p.title}</h3>
              <p className="text-sm text-[#9CA3AF] leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }); }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#EE1D25] hover:bg-[#CC1920] text-white text-sm font-medium transition-all duration-300 hover:shadow-[0_0_30px_rgba(238,29,37,0.3)]"
            data-testid="investor-cta"
          >
            {t("investment.cta")} <ArrowRight size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
